import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';
import { OptionText } from './components/BottomBarOptionStyles';

export const SequenceBottomBarWrapper = styled.div`
  margin-top: 6px;
  display: flex;
  justify-content: center;
  font-weight: 700;
  width: 100%;

  .save-sequence,
  .change-selection,
  .exit-sequence,
  .finish-process {
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 8px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.14);
    border-radius: 5px;

    &:hover {
      cursor: pointer;
    }

    ${OptionText} {
      color: ${darkgrey};
      font-size: 11px;
      margin-bottom: 6px;
    }
  }

  .finish-process {
    margin-left: 8px;
  }

  .change-selection {
    margin: 0 8px;
  }
`;
